<template>
  <div class="cr-actions-menu-wrap">
    <v-menu location="bottom end" offset="8" :close-on-content-click="true">
      <template #activator="{ props: menuProps }">
        <button
          type="button"
          class="cr-actions-trigger"
          aria-label="Product actions"
          v-bind="menuProps"
          @click.stop
        >
          <v-icon icon="mdi-dots-vertical" size="18" />
        </button>
      </template>

      <div class="cr-actions-menu" role="menu">
        <button
          type="button"
          class="cr-actions-menu__item"
          role="menuitem"
          @click="$emit('view', context)"
        >
          <span class="cr-actions-menu__icon cr-actions-menu__icon--view">
            <v-icon icon="mdi-eye-outline" size="18" />
          </span>
          <span class="cr-actions-menu__text">
            <span class="cr-actions-menu__title">Open product</span>
            <span class="cr-actions-menu__desc">Dashboard, reports, settings, fields &amp; dispositions</span>
          </span>
        </button>

        <button
          type="button"
          class="cr-actions-menu__item"
          role="menuitem"
          @click="$emit('edit', context)"
        >
          <span class="cr-actions-menu__icon cr-actions-menu__icon--edit">
            <v-icon icon="mdi-pencil-outline" size="18" />
          </span>
          <span class="cr-actions-menu__text">
            <span class="cr-actions-menu__title">Edit</span>
            <span class="cr-actions-menu__desc">Rename product or manage files</span>
          </span>
        </button>

        <button
          v-if="context.disabled"
          type="button"
          class="cr-actions-menu__item"
          role="menuitem"
          @click="$emit('enable', context)"
        >
          <span class="cr-actions-menu__icon cr-actions-menu__icon--view">
            <v-icon icon="mdi-play-circle-outline" size="18" />
          </span>
          <span class="cr-actions-menu__text">
            <span class="cr-actions-menu__title">Enable</span>
            <span class="cr-actions-menu__desc">Make this product active again</span>
          </span>
        </button>

        <button
          v-else
          type="button"
          class="cr-actions-menu__item"
          role="menuitem"
          @click="$emit('disable', context)"
        >
          <span class="cr-actions-menu__icon cr-actions-menu__icon--view">
            <v-icon icon="mdi-pause-circle-outline" size="18" />
          </span>
          <span class="cr-actions-menu__text">
            <span class="cr-actions-menu__title">Disable</span>
            <span class="cr-actions-menu__desc">Stop using this product</span>
          </span>
        </button>

        <button
          type="button"
          class="cr-actions-menu__item cr-actions-menu__item--danger"
          role="menuitem"
          @click="$emit('delete', context)"
        >
          <span class="cr-actions-menu__icon cr-actions-menu__icon--delete">
            <v-icon icon="mdi-trash-can-outline" size="18" />
          </span>
          <span class="cr-actions-menu__text">
            <span class="cr-actions-menu__title">Delete</span>
            <span class="cr-actions-menu__desc">Remove this product</span>
          </span>
        </button>
      </div>
    </v-menu>
  </div>
</template>

<script setup>
defineOptions({ name: 'ContextsActionMenu' })

defineProps({
  context: { type: Object, required: true },
})

defineEmits(['view', 'edit', 'enable', 'disable', 'delete'])
</script>
